module.exports = __webpack_public_path__ + "static/12-2888b5652c85bb090dc2e85a1bdcb04b.jpg";